import { createContext, useContext, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
 
import AnchorTemporaryDrawer from "./components/side-menu";
import CenterPanel from "./components/center-panel";
 
export function ToyotaIcon() {
    return (
        <svg
            width={200}
            height={40}
            viewBox="10 23 100 10"
        >
            <g transform="matrix(.134739 0 0 .134739 9.473036 16.054558)">
                <path d="M0 0.311h171.879v171.879H0z" fill="#eb0a1e" />
                <path d="M577.371 91.61l9.644 -25.286 9.629 25.286zm19.651 -39.644h-20.025l-27.984 68.563h17.349l6.374 -16.731h28.549l6.375 16.731H625zm-141.244 56.641c-11.301 0 -20.446 -10.194 -20.446 -22.775s9.145 -22.784 20.446 -22.784c11.281 0 20.441 10.201 20.441 22.784s-9.166 22.775 -20.441 22.775m0 -59c-20.005 0 -36.223 16.216 -36.223 36.216s16.216 36.209 36.223 36.209c19.991 0 36.216 -16.209 36.216 -36.209s-16.225 -36.216 -36.216 -36.216m-142.91 59c-11.281 0 -20.434 -10.194 -20.434 -22.775s9.151 -22.784 20.434 -22.784c11.295 0 20.448 10.201 20.448 22.784s-9.152 22.775 -20.448 22.775m0 -59c-20 0 -36.201 16.216 -36.201 36.216s16.203 36.209 36.201 36.209 36.216 -16.209 36.216 -36.209 -16.216 -36.216 -36.216 -36.216m89.516 2.35l-17.745 27.74 -17.759 -27.74H349.525l27.471 42.996v25.566h15.276V94.966l27.466 -43.001zm150.279 0h-58.616v13.148h21.711v55.415h15.291v-55.416h21.616V51.966zm-337.816 13.146h21.716v55.415h15.284V65.113h21.624V51.966h-58.625z" />
                <path
                    d="M85.939 47.231c-32.453 0 -57.291 16.735 -57.291 39.019 0 21.55 24.206 39.019 57.291 39.019s57.291 -17.469 57.291 -39.019c0 -22.284 -24.84 -39.019 -57.291 -39.019zm35.724 16.735c1.194 4.81 -4.409 10.822 -22.436 12.789 -1.2 -12.25 -4.834 -22.6 -10.855 -24.791 8.106 0.229 15.791 1.6 22.491 4.03 6.265 2.364 10.159 5.379 10.8 7.974zm-26.704 22.095c0 15.521 -4.661 21.955 -9.02 21.955s-9.02 -6.434 -9.02 -21.955l0.001 -0.161c2.896 0.245 5.911 0.374 9.019 0.374s6.122 -0.129 9.019 -0.374v0.161zm-9.024 -8.651c-3.04 0 -5.851 -0.086 -8.451 -0.246 1.369 -10.15 5.006 -16.05 8.454 -16.05s7.085 5.9 8.454 16.05c-2.6 0.161 -5.414 0.247 -8.456 0.247zM50.21 63.966c0.641 -2.581 4.496 -5.579 10.706 -7.939 6.723 -2.454 14.445 -3.836 22.584 -4.066 -6.022 2.191 -9.655 12.541 -10.856 24.791 -18.031 -1.965 -23.636 -7.977 -22.441 -12.789zm-13.114 20.878c0 -6.571 2.2 -12.25 6.029 -16.951 0.496 8.713 12.281 15.21 29.085 17.491l-0.003 0.679c0 21.021 5.389 32.164 11.363 34.466 -25.652 -0.921 -46.475 -16.723 -46.475 -35.684zm51.106 35.686c6.015 -2.401 11.469 -14.359 11.469 -34.469l-0.003 -0.679c16.804 -2.281 28.589 -8.779 29.085 -17.491 3.829 4.701 6.029 10.381 6.029 16.951 0 18.988 -20.879 34.804 -46.58 35.686z"
                    fill="#fff"
                />
            </g>
        </svg>
    );
}
 
export function UserProfileIcon() {
    return (
        <svg width="36" height="36" viewBox="0 0 70 65" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M70 32.5C70 50.4497 54.3305 65 35 65C15.6695 65 0 50.4497 0 32.5C0 14.5503 15.6695 0 35 0C54.3305 0 70 14.5503 70 32.5ZM45.5 22.75C45.5 25.3359 44.3938 27.8158 42.4246 29.6443C40.4555 31.4728 37.7848 32.5 35 32.5C32.2152 32.5 29.5445 31.4728 27.5754 29.6443C25.6062 27.8158 24.5 25.3359 24.5 22.75C24.5 20.1641 25.6062 17.6842 27.5754 15.8557C29.5445 14.0272 32.2152 13 35 13C37.7848 13 40.4555 14.0272 42.4246 15.8557C44.3938 17.6842 45.5 20.1641 45.5 22.75ZM35 60.125C41.007 60.134 46.8748 58.4462 51.8245 55.2857C53.9385 53.937 54.8415 51.3695 53.6095 49.2798C51.065 44.9475 45.815 42.25 35 42.25C24.185 42.25 18.935 44.9475 16.387 49.2798C15.1585 51.3695 16.0615 53.937 18.1755 55.2857C23.1252 58.4462 28.993 60.134 35 60.125Z" fill="#EB0A1E" />
        </svg>
 
    )
}
 
const ChatContext = createContext<any>(null);
 
const Canva = () => {
    const [selectedPrevMessage, setSelectedPrevMessage] = useState<any>();
    return (
        <ChatContext.Provider value={{ selectedPrevMessage }}>
        <div>
            <div id='topBar' style={{ display: "flex", justifyContent: "space-between" }}>
                <AppBar position="fixed"
                    sx={{
                        backgroundColor: 'transparent', // No background color
                        boxShadow: 'none',               // No box shadow
                    }}
                >
                    <Toolbar sx={{ justifyContent: 'flex-end', backGround: "white" }}>
                        <div>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={() => { }}
                                color="inherit"
                            >
                                <UserProfileIcon />
                            </IconButton>
 
                        </div>
                    </Toolbar>
                </AppBar>
            </div>
            <div id="centerPanel" style={{ paddingLeft: "20%" }}><CenterPanel /></div>
            <AnchorTemporaryDrawer setSelectedPrevMessage={setSelectedPrevMessage} />
        </div>
        </ChatContext.Provider>
    )
};
 
export default Canva;
 
export const useChat = () => {
    return useContext(ChatContext);
  };